import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, LoadingSpinner, PagePanel } from 'edenred-ui';

import { loadVoucherOrdersHistory } from '@epi-actions/orderHistory';
import { clearSavedOrderHistory } from '@epi-actions/api';
import { Pagination } from '@epi-shared/components';
import {
  getVoucherOrderHistory,
  getVoucherOrderHistoryTotalPages
} from '@epi-selectors/orderHistory';

import { getInitialState } from '@epi-store/orderHistory/orderHistory.slice';
import { VoucherOrderHistoryTable } from '../VoucherOrderHistoryTable';

export function VoucherOrderHistory() {
  const [page, setPage] = useState(1);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const voucherOrders = useSelector(getVoucherOrderHistory);
  const totalPages = useSelector(getVoucherOrderHistoryTotalPages);
  const orderHistoryInitialState = getInitialState();
  const initialRowsPerPage =
    orderHistoryInitialState.queryParameters.rowsPerPage;

  useEffect(() => {
    dispatch(loadVoucherOrdersHistory());
    return () => {
      dispatch(clearSavedOrderHistory());
    };
  }, []);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    dispatch(loadVoucherOrdersHistory({ page: newPage }));
  };

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    setPage(1);
    dispatch(
      loadVoucherOrdersHistory({ rowsPerPage: newRowsPerPage, page: 1 })
    );
  };

  const hasVoucherOrders = voucherOrders && voucherOrders.length > 0;
  const showPagination = totalPages > 1;

  return hasVoucherOrders ? (
    <Box mt={-5}>
      <PagePanel title={t('paper_vouchers.order_history.title')}>
        <VoucherOrderHistoryTable />
        {showPagination && (
          <Box mt={3}>
            <Pagination
              page={page}
              count={totalPages}
              rowsPerPageOptions={[5, 10, 15]}
              defaultRowsPerPage={initialRowsPerPage}
              onChangePage={handleChangePage}
              onRowPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        )}
      </PagePanel>
    </Box>
  ) : (
    <LoadingSpinner />
  );
}
